import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ChartSeriesDataPoint } from '@ndt/reports/shared/charts/chart-data-point-interface';
import { ChartBase } from '../chart-base';

//See https://swimlane.gitbook.io/ngx-charts/examples/line-area-charts/line-chart
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'qmg-line-chart',
    templateUrl: './line-chart.component.html',
    styleUrls: ['./line-chart.component.scss'],
    standalone: false
})
export class LineChartComponent extends ChartBase<ChartSeriesDataPoint> {}
